module.exports = "/fonts/payjak-picturemark-d-009df52ed8a7a400087c78c2ca9bc58c.svg";